<div [formGroup]="form">
  <div class="section">Interne Daten</div>
  <div class="grid">
    <div class="md:col-3">
      <label class="label" for="internalNumber">Objektnummer Intern</label>
      <input fullWidth id="internalNumber" nbInput formControlName="internalNumber">
      @if (hasError('internalNumber')) {
        @if (form.get('internalNumber')?.errors?.['required']) {
          <div class="error">Interne Nummer ist erforderlich!</div>
        } @else if (form.get('internalNumber')?.errors?.['duplicateInternalNumber']) {
          <div class="error">Interne Nummer bereits vorhanden!</div>
        }
      }
    </div>
  </div>
</div>
